import React, { useState, useEffect } from "react";
import { getStaffBusinessId } from "../../../utils/authHelper";
import { startCalendarOAuth } from "../../../utils/calendarOAuth";
import GoogleCalendarSVG from "../../../assets/icons/google_calendar.svg";
import MicrosoftOfficeLogo from "../../../assets/icons/ms-office-360.svg";
import FeatureLock from "../../../components/FeatureLock/FeatureLock";
import { FEATURE_IDS } from "../../../constants/featureAccess";

const ConnectToCalendarView = (props) => {
  const [dataSet, setDataSet] = useState([]);
  const [starting, setStarting] = useState(false);
  const businessId = getStaffBusinessId();
  const allowance = Number(props.allowance || 1);
  const atLimit = dataSet.length >= allowance;

  useEffect(() => {
    setDataSet(props.data || []);
  }, [props.data]);

  const onConnect = async (e, provider) => {
    e.preventDefault();
    if (starting || atLimit) return;
    setStarting(true);
    try {
      await startCalendarOAuth({
        businessId,
        provider,
        owner: "staff",
      });
    } finally {
      setStarting(false);
    }
  };

  return (
    <section className="integreted-calenders calend-integ w-100">
      <div className="bg-div">
        <div className="section-title d-flex justify-content-between align-items-center">
          <h2>Calendar Connections</h2>
          {dataSet.length > 0 && (
            <a
              href="#"
              className="bootstrap-default-btn btn-calender-account"
              onClick={(e) => {
                e.preventDefault();
                props.setCalendarIntegrationView("1");
              }}
            >
              Connected Calendars
            </a>
          )}
        </div>
        {atLimit && (
          <p className="mt-2 mb-0">
            You have reached your calendar limit ({dataSet.length}/{allowance}).
            Ask your organization admin to request more slots.
          </p>
        )}
      </div>

      <div className="calender-clients">
        <div className="row-1 row">
          <div className="col-xl-4 col-lg-6">
            <h2>Google</h2>
            <FeatureLock featureId={FEATURE_IDS.CALENDAR_INTEGRATIONS}>
              <a
                href="#"
                onClick={(e) => onConnect(e, "google")}
                aria-disabled={starting || atLimit}
                style={
                  starting || atLimit
                    ? { pointerEvents: "none", opacity: 0.6 }
                    : undefined
                }
              >
                <div className="calender-client-google">
                  <label htmlFor="googleCalender" role="button">
                    <img src={GoogleCalendarSVG} alt="" />
                    <span>Google Calender</span>
                  </label>
                </div>
              </a>
            </FeatureLock>
          </div>
        </div>
        <div className="row-2 row">
          <div className="col-12">
            <h2>Microsoft</h2>
          </div>
          {/* Staff may connect multiple Outlook accounts up to allowance — do not hide after the first. */}
          <div className="col-xl-4 col-lg-6">
            <FeatureLock featureId={FEATURE_IDS.CALENDAR_INTEGRATIONS}>
              <a
                href="#"
                onClick={(e) => onConnect(e, "outlook")}
                aria-disabled={starting || atLimit}
                style={
                  starting || atLimit
                    ? { pointerEvents: "none", opacity: 0.6 }
                    : undefined
                }
              >
                <div className="calender-client-office">
                  <label htmlFor="officeCalender" role="button">
                    <img src={MicrosoftOfficeLogo} alt="" />
                    <span>Office 365 Calender</span>
                  </label>
                </div>
              </a>
            </FeatureLock>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConnectToCalendarView;
